module.exports = __webpack_public_path__ + "static/img/teamDataTableCardBg.485bb98.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/invite/teamDataTableCardBg.png
// module id = RyfP
// module chunks = 0